import * as tslib_1 from "tslib";
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { RequestV2Service } from '@providers/request-service-v2/request-v2.service';
import * as i0 from "@angular/core";
import * as i1 from "../Providers/request-service-v2/request-v2.service";
import * as i2 from "@angular/platform-browser";
import * as i3 from "@angular/router";
var DataMaterialsService = /** @class */ (function () {
    function DataMaterialsService(requestV2Service, sanitization, router) {
        this.requestV2Service = requestV2Service;
        this.sanitization = sanitization;
        this.router = router;
        // Data Fetch
        this.quotationMaterials = [];
        this.quotationMaterialsValidation = [];
        this.projectRooms = [];
        // Get categories ids and alternative Materials
        this.idsCategories = [];
        this.topAlternative = [];
        this.refreshData = true;
        this.units = [];
        this.percentageValidated = 0;
        // Header mobile of selection Theme
        this.displayHeaderMobileSelectionTheme = true;
        this.chaptersWithMaterials = [];
        this.projectMaterials = { items: [] };
    }
    DataMaterialsService.prototype.randomIntFromInterval = function (min, max, mat, indexSelected) {
        if (indexSelected === 'first') {
            return Math.floor(Math.random() * (max - min + 1) + min);
        }
        if (indexSelected === 'second') {
            var index = Math.floor(Math.random() * (max - min + 1) + min);
            if (index === mat.alternativeMat.indexSelectedFirst) {
                index = this.randomIntFromInterval(min, max, mat, 'second');
            }
            return index;
        }
    };
    DataMaterialsService.prototype.getUnitType = function (version) {
        var unit = this.units.find(function (u) { return u.id === version.id_unit_type; });
        return (unit) ? unit.type : 'NC';
    };
    DataMaterialsService.prototype.detectStatusMat = function (version) {
        var isFoundMat = this.quotationMaterialsValidation
            .find(function (m) { return m.id_material_version === version.id; });
        if (!isFoundMat) {
            return 'initial';
        }
        var value = 'initial';
        switch (true) {
            case !!isFoundMat.dates.validation_lw:
                value = 'validation_lw';
                break;
            case !!isFoundMat.dates.validation_by_signature:
                value = 'validation_by_signature';
                break;
            default:
                return value;
        }
        return value;
    };
    DataMaterialsService.prototype.detectDateValidation = function (version) {
        var isFoundMat = this.quotationMaterialsValidation
            .find(function (m) { return m.id_material_version === version.id; });
        if (!isFoundMat) {
            return null;
        }
        if (isFoundMat.dates && isFoundMat.dates.validation_lw) {
            return new Date(isFoundMat.dates.validation_lw);
        }
        if (isFoundMat.dates && isFoundMat.dates.validation_by_signature) {
            return new Date(isFoundMat.dates.validation_by_signature);
        }
        return null;
    };
    DataMaterialsService.prototype.formatMaterials = function (quotMats) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var matInitials, finalQuotMat;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                matInitials = quotMats.filter(function (mat) {
                    var isSuggestion = _this.quotationMaterialsValidation
                        .find(function (quotValid) {
                        return quotValid.id_original_material_version === mat._related.material_versions[0].id
                            && !!quotValid.id_material_version
                            && !!quotValid.dates.customer_suggestion;
                    });
                    return (!isSuggestion);
                });
                finalQuotMat = matInitials;
                return [2 /*return*/, finalQuotMat.map(function (mat) {
                        var imagesMat = [];
                        if (mat._related.material_version_images[0] !== null) {
                            imagesMat = mat._related.material_version_images
                                .map(function (img) { return (tslib_1.__assign({}, img, { url: _this.getSafeStyleImgURL(img.id_image, 'small') })); }).filter(function (img) { return img.id_image !== null; });
                        }
                        while (imagesMat.length < 3) {
                            imagesMat.push({
                                id_image: null,
                                url: '/assets/images/placeholder-img.png'
                            });
                        }
                        var v = tslib_1.__assign({}, mat._related.material_versions[0]);
                        v.unitType = _this.getUnitType(mat._related.material_versions[0]);
                        var quotMatComment = {};
                        if (mat._related.quotation_material_comments
                            && mat._related.quotation_material_comments.length > 0) {
                            quotMatComment.content = mat._related.quotation_material_comments[0].comment;
                            quotMatComment.date = mat._related.quotation_material_comments[0].date;
                        }
                        return {
                            id_quotation_material: mat.id,
                            name: mat._related.material_versions[0].name,
                            supplier: (mat._related.material_suppliers.length > 0
                                && mat._related.material_suppliers[0] !== null)
                                ? mat._related.material_suppliers[0].name
                                : 'NC',
                            brand: (mat._related.material_brands.length > 0 && mat._related.material_brands[0] !== null)
                                ? mat._related.material_brands[0].name
                                : 'Marque Inconnue',
                            id_quotation_chapter: (mat._related.quotation_chapters.length > 0)
                                ? mat._related.quotation_chapters[0].id
                                : null,
                            quotation_chapter: (mat._related.quotation_chapters.length > 0)
                                ? mat._related.quotation_chapters[0].title
                                : 'Chapitre Inconnu',
                            id_quotation: (mat._related.quotation_versions.length > 0)
                                ? mat._related.quotation_versions[0].id_quotation
                                : null,
                            id_quotation_service: mat._related.quotation_services[0].id,
                            id_category: (mat._related.material_product_categories.length > 0)
                                ? mat._related.material_product_categories[0].id
                                : null,
                            eco: !!(mat._related.material_product_categories.length > 0
                                && mat._related.material_product_categories.find(function (i) { return i.name === 'Eco-responsable'; })),
                            ids_categories_children: mat._related._categories_childrens
                                .map(function (c) { return ({ id: c.id, name: c.name }); }),
                            comment: quotMatComment,
                            version: v,
                            versionSpecification: mat._related.material_version_specifications
                                .filter(function (s) { return s !== null && s.value; }),
                            quantity: mat.quantity,
                            quantity_customer: (mat._related.quotation_service_rooms.length > 0)
                                ? mat.quantity / mat._related.quotation_service_rooms.length
                                : mat.quanty,
                            suggestion: {
                                isSuggestion: false,
                                matSuggested: null
                            },
                            status: _this.detectStatusMat(v),
                            date_validation: _this.detectDateValidation(v),
                            images: imagesMat,
                            mainImage: (mat._related.material_version_images.length > 0
                                && mat._related.material_version_images[0] !== null
                                && mat._related.material_version_images[0].id_image !== null)
                                ? _this.getSafeStyleImgURL(mat._related.material_version_images[0].id_image, 'large')
                                : null,
                            projectRooms: (mat._related.project_rooms.length > 0)
                                ? mat._related.project_rooms.map(function (projectRoom) {
                                    var room = _this.projectRooms.find(function (r) { return r.id_room_type === projectRoom.id_room_type; });
                                    return tslib_1.__assign({}, projectRoom, { icon: room ? room.icon : null });
                                })
                                : [],
                            alternativeMat: {
                                isLoaded: false,
                                indexSelectedFirst: 0,
                                indexSelectedSecond: 0,
                                materials: []
                            }
                        };
                    })];
            });
        });
    };
    DataMaterialsService.prototype.formatFullProjectRoomsWithMat = function () {
        var _this = this;
        var projectRooms = this.projectRooms.map(function (pR) {
            var projectRoom = tslib_1.__assign({}, pR);
            for (var i = 0; i < _this.quotationMaterials.length; i = i + 1) {
                var quotMat = _this.quotationMaterials[i];
                var isInculeInProjectRoom = quotMat.projectRooms.find(function (pr) { return pr.id === projectRoom.id; });
                if (isInculeInProjectRoom) {
                    projectRoom.materials.push(quotMat);
                }
            }
            return projectRoom;
        });
        var nonAttributeRoomIndex = projectRooms.findIndex(function (r) { return r._related.room_types[0].id === 23; });
        var nonAttributeMats = this.quotationMaterials.filter(function (qM) { return qM.projectRooms.length === 0; });
        for (var i = 0; i < nonAttributeMats.length; i = i + 1) {
            projectRooms[nonAttributeRoomIndex].icon = ['fal', 'tools'];
            projectRooms[nonAttributeRoomIndex].label = 'Tous matériaux';
            projectRooms[nonAttributeRoomIndex].materials.push(nonAttributeMats[i]);
        }
        return projectRooms;
    };
    DataMaterialsService.prototype.sortMatByStatus = function () {
        return this.projectRooms.map(function (pR) {
            var matsInitial = pR.materials
                .filter(function (m) { return !['validation_lw', 'validation_by_signature'].includes(m.status); });
            var matsValidated = pR.materials
                .filter(function (m) { return ['validation_lw', 'validation_by_signature'].includes(m.status); });
            pR.materials = tslib_1.__spread(matsInitial, matsValidated);
            return pR;
        });
    };
    DataMaterialsService.prototype.getSafeStyleImgURL = function (id, size) {
        if (size === void 0) { size = 'small'; }
        var result;
        if (typeof id !== 'undefined') {
            var sizeImg = (size === 'small') ? 'size=104x104' : 'size=380x380';
            result = this.sanitization
                .bypassSecurityTrustUrl(environment.api_url + "/images/" + id + "?" + sizeImg);
        }
        return result;
    };
    // Format project Rooms with new fields (icon, materials, etc...)
    DataMaterialsService.prototype.formatProjectRooms = function (projectRooms) {
        var newProjectRooms = projectRooms.map(function (pR) {
            var icon = ['fal'];
            var projectRoom = tslib_1.__assign({}, pR);
            icon[1] = projectRoom._related.room_types[0].icon;
            projectRoom.icon = icon;
            projectRoom.materials = [];
            projectRoom.materialsValidated = 0;
            return projectRoom;
        });
        return newProjectRooms;
    };
    DataMaterialsService.prototype.buildIdsCategories = function () {
        var ids = this.quotationMaterials.map(function (mat) { return mat.id_category; }).filter(function (c) { return c; });
        ids = tslib_1.__spread(new Set(ids));
        return ids;
    };
    DataMaterialsService.prototype.fetchTopAlternatives = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(this.idsCategories.map(function (id) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var mats, m, mat;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.requestV2Service.getTopAlternativeMaterial(id)];
                                    case 1:
                                        mats = _a.sent();
                                        for (m in mats.items) {
                                            mat = mats.items[m];
                                            mat.version.version_images = mat.version.version_images.filter(function (i) { return i.id_image; });
                                            mat.version.version_images_urls = null;
                                            mat.mainImage = null;
                                            mat.version.unitType = this.getUnitType(mat.version);
                                            if (mat.version.version_images.length > 1) {
                                                mat.version.version_images_urls = mat.version.version_images.map(function (i) {
                                                    return {
                                                        url: environment.api_url + "/images/" + i.id_image + "?size=300x300"
                                                    };
                                                });
                                            }
                                        }
                                        return [2 /*return*/, {
                                                id_category: id,
                                                materials: mats.items.filter(function (mat) {
                                                    if (mat.version.version_images.length > 0) {
                                                        return true;
                                                    }
                                                })
                                            }];
                                }
                            });
                        }); }))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    DataMaterialsService.prototype.getProjectRoomsWithAlternativeMats = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.fetchTopAlternatives()];
                    case 1:
                        _a.topAlternative = _b.sent();
                        return [2 /*return*/, this.projectRooms.map(function (room) {
                                var r = tslib_1.__assign({}, room);
                                r.materials.map(function (mat) {
                                    var m = tslib_1.__assign({}, mat);
                                    var findAlternatives = _this.topAlternative.find(function (c) { return c.id_category === mat.id_category; });
                                    m.alternativeMat.materials = (findAlternatives ? findAlternatives.materials : []);
                                    m.alternativeMat.isLoaded = true;
                                    m.alternativeMat.indexSelectedFirst = (m.alternative
                                        && m.alternativeMat.materials.length > 0)
                                        ? _this.randomIntFromInterval(0, m.alternativeMat.materials.length - 1, m, 'first')
                                        : 0;
                                    m.alternativeMat.indexSelectedSecond =
                                        (m.alternativeMat.materials.length > 0 && m.alternativeMat.materials.length !== 1)
                                            ? _this.randomIntFromInterval(0, m.alternativeMat.materials.length - 1, m, 'second')
                                            : m.alternativeMat.indexSelectedFirst;
                                    return m;
                                });
                                return r;
                            })];
                }
            });
        });
    };
    DataMaterialsService.prototype.calcPercentageValidated = function () {
        return Math.round(((this.quotationMaterialsValidation.length * 100)
            / this.quotationMaterials.length));
    };
    DataMaterialsService.prototype.initChaptersWithMaterials = function (formattedMaterials) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var chapters;
            return tslib_1.__generator(this, function (_a) {
                chapters = [];
                formattedMaterials.forEach(function (material) {
                    var chapter = chapters.find(function (chapter) { return chapter.id === material.id_quotation_chapter; });
                    if (!chapter) {
                        chapters.push({
                            id: material.id_quotation_chapter,
                            title: material.quotation_chapter,
                            materials: [
                                material
                            ]
                        });
                    }
                    else {
                        chapter.materials = tslib_1.__spread(chapter.materials, [material]);
                    }
                });
                this.chaptersWithMaterials = tslib_1.__spread(chapters);
                return [2 /*return*/];
            });
        });
    };
    DataMaterialsService.prototype.computeQuotationMaterialsData = function (fullInit) {
        if (fullInit === void 0) { fullInit = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var quotationMaterials, idsQuotMatToHide, quotationMaterialsValidation, _a, unitsResults, projectRooms, _b, _c, _d;
            var _this = this;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0: return [4 /*yield*/, this.requestV2Service.getQuotationMaterials(null, this.currentProject.id, true, 'all', 'false')];
                    case 1:
                        quotationMaterials = _e.sent();
                        idsQuotMatToHide = quotationMaterials.items.filter(function (quotMat) {
                            if (quotMat._related.material_product_categories.length === 0) {
                                return true;
                            }
                            return quotMat._related.material_product_categories[0].slug === 'petites-fournitures';
                        }).map(function (mat) { return mat._related.material_versions[0].id; });
                        quotationMaterials.items = quotationMaterials.items.filter(function (quotMat) {
                            if (quotMat._related.material_product_categories.length === 0) {
                                return true;
                            }
                            return quotMat._related.material_product_categories[0].slug !== 'petites-fournitures';
                        });
                        return [4 /*yield*/, this.requestV2Service
                                .getListQuotationMaterialValidation(this.currentProject.id, 'all')];
                    case 2:
                        quotationMaterialsValidation = _e.sent();
                        // Filter quotation material validations.
                        // Hide materials related to "petites fournitures" category
                        this.quotationMaterialsValidation = quotationMaterialsValidation.items
                            .filter(function (quotMat) { return idsQuotMatToHide.indexOf(quotMat.id_material_version) === -1; });
                        _a = this;
                        return [4 /*yield*/, this.formatMaterials(quotationMaterials.items)];
                    case 3:
                        _a.quotationMaterials = _e.sent();
                        this.percentageValidated = this.calcPercentageValidated();
                        if (!fullInit) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.requestV2Service.getUnitTypes()];
                    case 4:
                        unitsResults = _e.sent();
                        this.units = unitsResults.items;
                        return [4 /*yield*/, this.requestV2Service.getProjectRooms(this.currentProject)];
                    case 5:
                        projectRooms = _e.sent();
                        _b = this;
                        return [4 /*yield*/, this.formatProjectRooms(projectRooms.items)];
                    case 6:
                        _b.projectRooms = _e.sent();
                        _c = this;
                        return [4 /*yield*/, this.formatFullProjectRoomsWithMat()];
                    case 7:
                        _c.projectRooms = _e.sent();
                        _d = this;
                        return [4 /*yield*/, this.sortMatByStatus()];
                    case 8:
                        _d.projectRooms = _e.sent();
                        return [4 /*yield*/, this.initChaptersWithMaterials(this.quotationMaterials)];
                    case 9:
                        _e.sent();
                        this.idsCategories = this.buildIdsCategories();
                        // Add Alternative in async. Load first all material even if alternatives are not loaded
                        this.getProjectRoomsWithAlternativeMats().then(function (updatedProjectRooms) {
                            _this.projectRooms = updatedProjectRooms;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    DataMaterialsService.prototype.computeProjectMaterialsData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var projectMaterials;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.projectMaterials.items = [];
                        if (!this.currentProject) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.requestV2Service
                                .getProjectMaterials(this.currentProject.id, true, 'all')];
                    case 1:
                        projectMaterials = _a.sent();
                        if (projectMaterials && projectMaterials.items.length > 0) {
                            this.projectMaterials.items = projectMaterials.items.filter(function (pm) { return pm.state !== 'cancelled'; });
                        }
                        else {
                            this.projectMaterials.items = [];
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    DataMaterialsService.prototype.getProjectMaterials = function () {
        return this.projectMaterials;
    };
    DataMaterialsService.prototype.hasProjectMaterials = function () {
        return this.projectMaterials.items.length > 0;
    };
    DataMaterialsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DataMaterialsService_Factory() { return new DataMaterialsService(i0.ɵɵinject(i1.RequestV2Service), i0.ɵɵinject(i2.DomSanitizer), i0.ɵɵinject(i3.Router)); }, token: DataMaterialsService, providedIn: "root" });
    return DataMaterialsService;
}());
export { DataMaterialsService };
